var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 7.8h8.4m-8.4 4.8h8.4M5.76 3h12.48c.862 0 1.56.806 1.56 1.8V21l-2.6-1.8-2.6 1.8-2.6-1.8L9.4 21l-2.6-1.8L4.2 21V4.8C4.2 3.806 4.9 3 5.76 3Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptIcon);
export default __webpack_public_path__ + "static/media/receipt-icon.46d427e7e9d38d8e9e0e4a5c09b1fd76.svg";
export { ForwardRef as ReactComponent };